import React, { useEffect } from 'react';
import Home from './routes/home'
import { Route, Routes, useLocation } from 'react-router-dom'
import Numeros from './routes/numeros';
import Podcast from './routes/podcast';
import Login from './routes/login';
import Adminmain from './routes/adminmain';
import AdminNumeros from './routes/adminNumeros';
import Contacto from './routes/contacto';
import About from './routes/about';
import './App.css';

function App(){
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname]);
    return (
        <div className='App'>
        <Routes>
           <Route  path="/" element={<Home />}/>
           <Route  path="/numeros" element={<Numeros/>}/>
           <Route  path="/podcast" element={<Podcast/>}/>
           <Route  path="/entradasecreta" element={<Login/>}/>
           <Route  path='/adminmain' element={<Adminmain/>}/>
           <Route path='/adminmain/numeros' element={<AdminNumeros/>}/>
           <Route  path='/contacto' element={<Contacto/>}/>
           <Route  path='/acercade' element={<About/>}/>
        </Routes>
        </div>
    );
}

export default App;